const API = {
  auth: {
    register: "/auth/register",
    login: "/auth/loginAdmin",
  },
  panel: {
    profile: "/panel/profile",
    update: "/panel/update-profile",
    updateAvatar: "/panel/upload-profile-image",
    getProductDetails: "/panel/get-product-detail",
    categories: "/auth/get-categories-list",
    getUserInvoices: "/panel/get-user-invoices",
    getUserTransactions: "/panel/get-user-transactions",
    getProducts: "/panel/get-products-with-category",
    newOpinion: "/panel/add-user-opinions",
    newInvoice: "/panel/add-new-invoice",
  },
  admin: {
    // categories
    addCategory: "/admin/add-categorie",
    updateCategory: "/admin/update-categorie",
    deleteCategory: "/admin/delete-categorie",

    // products
    getProducts: "/admin/products",
    getProductDetails: "/panel/get-product-detail",
    addProduct: "/admin/add-product",
    uploadProductImage: "/admin/upload-product-image",
    uploadProductDetailImages: "/admin/upload-product-detail-images",
    editProduct: "/admin/edit-product",
    deleteProduct: "/admin/delete-product",

    // users
    getUsersList: "/admin/get-users-list",
    editUserProfile: "/admin/edit-user-profile",
    editUserAvatar: "/admin/update-user-avatar-by-admin",
    chargingTheUserWallet: "/admin/charging-the-user-wallet",

    // admins
    getAdminsList: "/admin/get-admins-list",

    // transactions
    getTransactionsList: "/admin/get-transactions-list",

    // invoices
    getInvoicesList: "/admin/get-invoices-list",
    acceptInvoice: "/admin/accept-invoice",
    endInvoice: "/admin/end-invoice",

    // landing
    landing: {
      getAllLandingData: "/auth/get-landing-data",
      mainBanners: {
        getMainBanners: "auth/get-landing-main-banners",
        deleteMainBanner: "admin/delete-landing-main-banner",
      },
      aboutUs: {
        updateMainBanner: "admin/about-us-main-banner",
        updateContent: "admin/about-us-content-text",
        getContactUs: "auth/get-landing-data",
      },

      shopMainBanners: {
        getShopMainbanners: "auth/get-shop-main-banners",
        createShopMainBanner: "admin/create-shop-main-banner",
        deleteShopMainBanner: "admin/delete-shop-main-banner",
      },

      contactUs: "admin/about-us-contact-us",

      certificates: "admin/about-us-create-certificate",
      getCertificates: "auth/get-certificates",
      getCatalogs: "auth/get-catalogs",
      deleteCertificate: "admin/about-us-delete-certificate",
      uploadCertificateImage: "admin/upload-certificate-image",
      addNewCatalog: "admin/add-new-catalog",
      updateCatalogImage: "admin/update-catalog-image",
      deleteCatalog: "admin/delete-catalog",

      findLandingProductsByCategory: "auth/find-product-landing-by-category",
      findLandingProductById: "auth/find-landing-product",

      majorShopping: {
        uploadMainBanner: "admin/major-shopping-main-banner",
        updateContent: "admin/major-shopping-content-box",
      },

      homePage: {
        updateMainBanner: "admin/create-landing-main-banner",
        aboutUsMainBanner: "admin/home-page-about-us-main-banner",
        updateAboutUsContent: "admin/home-page-about-us-content-box",
        updateStatueContent: "admin/home-page-statue-content",
        pushStatueImage: "admin/create-landing-statue",
        getStatues: "auth/get-landing-statues",
        deleteStatue: "admin/delete-landing-statue",
      },

      video: {
        createVideo: "admin/create-landing-video",
        getVideoHistory: "auth/get-landing-videos",
        deleteVideo: "admin/delete-landing-video",
        updateVideo: "admin/update-landing-video",
      },

      footerAddress: {
        createFooterAddress: "admin/create-footer-address",
        deleteFooterAddress: "admin/delete-footer-address",
        getFooterAddresses: "auth/get-footer-address",
      },

      factoryAddress: {
        createFactoryAddress: "admin/create-factory-address",
        deleteFactoryAddress: "admin/delete-factory-address",
        getFactoryAddresses: "auth/get-factories-address",
      },

      majorShoppingInfo: {
        createMajorShoppingInfo: "admin/create-major-shopping-info",
        deleteMajorShoppingInfo: "admin/delete-major-shopping-info",
        getMajorShoppingInfos: "auth/get-major-shopping-info",
      },

      category: {
        createLandingCategory: "admin/create-landing-category",
        uploadLandingCategoryImage: "admin/upload-landing-category-image",
        uploadLandingCategoryBanner: "admin/upload-landing-category-banner",
        getAllLandingCategories: "auth/get-landing-categories",
        deleteLandingCategory: "admin/delete-landing-category",
        editLandingCategoryImage: "admin/edit-landing-category-image",
        uploadCategoryService: "admin/create-landing-service",
        getServicesByCategory: "auth/get-landing-services",
        deleteCategoryService: "admin/delete-landing-service",
        updateAluminiumCategory: "admin/aluminium-category",
        updatePotlidCategory: "admin/potlid-category",
      },

      subCategories: {
        getSubCategories: "auth/get-landing-all-sub-categories",
        createSubCategory: "admin/create-sub-category",
        deleteCategory: "admin/delete-sub-category",
      },

      moreBox: {
        createMoreBox: "admin/create-landing-more-box",
        uploadMoreBoxImage: "admin/upload-image-more-box",
        getMoreBoxes: "auth/get-all-landing-more-boxes",
        deleteMoreBox: "admin/delete-more-box",
      },

      product: {
        createLandingProduct: "admin/create-landing-product",
        uploadLandingProductImage: "admin/upload-landing-product-image",
        uploadLandingProductImages: "admin/upload-landing-product-images",
        editLandingProduct: "admin/edit-landing-product",
        deleteLandingProduct: "admin/delete-landing-product",
      },

      faq: {
        createFaq: "admin/create-landing-faq",
        getFaqs: "auth/get-landing-faqs",
        deleteFaq: "admin/delete-landing-faq",
      },

      offer: {
        getLandingOffers: "auth/get-landing-offers",
        createOffer: "admin/create-landing-offer",
        deleteOffer: "admin/delete-landing-offer",
      },
    },
  },
};

export default API;
